var map = {
	"./FullMoonFace.svg": "58d1",
	"./LoveYouGesture.svg": "da30",
	"./bilet.svg": "fe28",
	"./bowler.svg": "2b5d",
	"./foots.svg": "4f40",
	"./ghost.svg": "624a",
	"./gun.svg": "616c",
	"./larva.svg": "0a1f",
	"./mask.svg": "ae7a",
	"./matreshka.svg": "3b9f",
	"./moai.svg": "8a06",
	"./paper.svg": "eaec",
	"./question.svg": "2554",
	"./ribbon.svg": "45c2",
	"./shaka.svg": "ae5f",
	"./warrior.svg": "1036",
	"./wood.svg": "3608"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2304";